import React from 'react';
import {
  Container,
  LeftWrapper,
  ImgWrapper,
  LogoImg,
  Content,
  Main,
} from './AuthLayout.styled';

interface AuthLayoutProps {
  children: React.ReactNode;
  isShowAlert?: boolean;
  login?: boolean;
}

const AuthLayout = ({
  children,
  isShowAlert = false,
  login = true,
}: AuthLayoutProps) => {
  return (
    <Container $login={login}>
      <LeftWrapper>
        <ImgWrapper>
          <LogoImg src="/assets/logo-lg.svg" alt="logo" />
        </ImgWrapper>
      </LeftWrapper>
      <Content data-cy="content">
        <Main $isShowAlert={isShowAlert}>{children}</Main>
      </Content>
    </Container>
  );
};

export default AuthLayout;
